import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {RecordsTable} from "../tables/RecordsTable.tsx";
import {useAccountApplications} from "../hooks/useAccountApplications.ts";
import {useParams} from "react-router-dom";

export const IndexPage = () => {

    const {id: accountId} = useParams()
    if (!accountId) {
        throw new Error('accountId is required parameter')
    }

    const {
        visibleItems,
    } = useAccountApplications(accountId);

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
        >
            <SimplePageContentWrapper>
                <RecordsTable records={visibleItems}/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
